import React from 'react';
import Tab from '@material-ui/core/Tab';
function TabTitle({ title, subtitle }) {
    return (React.createElement("div", null,
        React.createElement("div", null, title),
        React.createElement("div", null, subtitle)));
}
const AccomodationTab = (props) => React.createElement(Tab, Object.assign({}, props, { label: React.createElement(TabTitle, { title: props.title, subtitle: props.subtitle }), value: props.value, disableRipple: true }));
export default AccomodationTab;
